export default __webpack_public_path__ + "static/media/1938.d1fabd5b.png";